import {
	parseQuizResponsePayload,
	type QuizResponsePayload,
} from "./quiz-response-payload";

export interface HydrateQuizPlayerResponseParams {
	responsePayload?: unknown | null;
	answerId?: string | null;
	questionFormat?: string | null;
}

/**
 * Prefer canonical `responsePayload`. Legacy rows without payload hydrate MCS from `answerId` only.
 */
export function hydrateQuizPlayerResponse(
	params: HydrateQuizPlayerResponseParams,
): QuizResponsePayload | null {
	const fromPayload = parseQuizResponsePayload(params.responsePayload);
	if (fromPayload) {
		return fromPayload;
	}
	const answerId =
		typeof params.answerId === "string" ? params.answerId.trim() : "";
	if (!answerId) {
		return null;
	}
	return {
		format: "MULTIPLE_CHOICE_SINGLE",
		selectedAnswerId: answerId,
	};
}
